/**
 * Abstract base handler with default no-op implementations for optional methods.
 */

import { z } from "zod"

import type {
  ClientValidationContext,
  CompletionValidationContext,
  ExtensionHandler,
  ExtensionManifest,
  SerializedAnnotation,
  StoredAnnotation
} from "./_interface.ts"

export abstract class BaseExtensionHandler implements ExtensionHandler {
  abstract readonly type: string
  abstract readonly manifest: ExtensionManifest

  abstract getConfigSchema(): z.ZodType<any>
  abstract getCreateSchema(): z.ZodType<any>
  abstract getUpdateSchema(): z.ZodType<any>
  abstract serializeForDb(apiData: unknown): SerializedAnnotation
  abstract deserializeFromDb(stored: StoredAnnotation): unknown
  abstract getExportColumns(templateSchema: unknown): string[]
  abstract toExportRow(annotations: StoredAnnotation[], templateSchema: unknown): Record<string, string | number>

  getProjectConfigSchema(): z.ZodType<any> {
    return z.strictObject({})
  }

  getEditRegionDomain(_templateSchema: unknown, _projectConfig: unknown): string | null {
    return null
  }

  validateCompletionClient(_context: ClientValidationContext): { valid: boolean; errors: string[] } {
    return { valid: true, errors: [] }
  }

  validateForCompletion(
    _annotations: StoredAnnotation[],
    _templateSchema: unknown,
    _context: CompletionValidationContext
  ): { valid: boolean; errors: string[] } {
    return { valid: true, errors: [] }
  }

  validateForSubmission(
    _annotations: StoredAnnotation[],
    _templateSchema: unknown
  ): { valid: boolean; errors: string[] } {
    return { valid: true, errors: [] }
  }
}
